import { Button, Dialog } from '../../../components/ui';
import { useLoi } from '../../../hooks/useLoi';
import { useT } from '../../../i18n';
import { soVN } from '../../../lib/dinh-dang';
import { LoiTrongHop } from '../../tenant/components/phan-form';
import { xoaDuoc } from '../nghiep-vu/cay';
import type { Department } from '../types';

/**
 * Hộp xác nhận xoá phòng ban (`DELETE /api/v1/departments/{id}`).
 *
 * Server chỉ xoá phòng ban không còn người và không còn phòng con (ADR-0014).
 * Biết trước là không xoá được thì hộp nói vì sao và cách gỡ, không có nút
 * xoá — bấm rồi mới nhận `409` là bắt người dùng làm một việc chắc chắn hỏng.
 * Lỗi của lần xoá (có người vừa được gán vào) hiện trong hộp, hộp không đóng.
 */
export function HopXoaPhongBan({
  open,
  phongBan,
  dangChay,
  loi,
  onClose,
  onXacNhan,
}: {
  open: boolean;
  /** Giữ nguyên khi hộp đang đóng, để tiêu đề không nháy trống lúc mờ dần. */
  phongBan: Department | null;
  dangChay: boolean;
  loi: unknown;
  onClose: () => void;
  onXacNhan: (phongBan: Department) => void;
}) {
  const { t, locale } = useT();
  const dichLoi = useLoi();
  const duoc = phongBan ? xoaDuoc(phongBan) : false;
  const ten = phongBan?.name ?? '';

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={duoc ? t('coCauToChuc.xnXoaTieuDe', { ten }) : t('coCauToChuc.chuaXoaTieuDe', { ten })}
      width={480}
      destroyOnHidden
      footer={
        <div className="flex flex-wrap justify-end gap-3">
          <Button variant="outline" size="md" onClick={onClose}>
            {duoc ? t('chung.huy') : t('chung.dong')}
          </Button>
          {duoc && (
            <Button
              variant="destructive"
              size="md"
              loading={dangChay}
              onClick={() => phongBan && onXacNhan(phongBan)}
            >
              {t('coCauToChuc.xoaPhongBan')}
            </Button>
          )}
        </div>
      }
    >
      <div className="space-y-3 pt-2">
        {duoc ? (
          <p className="text-sm leading-relaxed text-content-secondary">{t('coCauToChuc.xnXoaThan')}</p>
        ) : (
          <ul className="list-disc space-y-1.5 pl-5 text-sm leading-relaxed text-content-secondary">
            {(phongBan?.user_count ?? 0) > 0 && (
              <li>{t('coCauToChuc.chuaXoaNguoi', { so: soVN(phongBan?.user_count ?? 0, locale) })}</li>
            )}
            {(phongBan?.child_count ?? 0) > 0 && (
              <li>{t('coCauToChuc.chuaXoaCon', { so: soVN(phongBan?.child_count ?? 0, locale) })}</li>
            )}
          </ul>
        )}
        {Boolean(loi) && <LoiTrongHop>{dichLoi(loi)}</LoiTrongHop>}
      </div>
    </Dialog>
  );
}
